import { useQuery } from 'data-fetching-client';
import getIn from 'immutable-less/transmute/getIn';
import { useHistory, useLocation } from 'react-router-dom';
import { atomicQueryUpdate } from 'automation-ui-routing/historyUtils';
import { parseLocation } from 'automation-ui-routing/utils';
import { CLASSIC_ENROLL_IN_WORKFLOW, ENROLL_IN_FLOW } from 'automation-ui-action-features/constants/ActionTypes';
import { CONTACT_ID } from 'automation-ui-references/object-types/CRMObjectTypes';
import ApplicationHistoryFilters from 'automation-ui-management/records/ApplicationHistoryFilters/ApplicationHistoryFilters';
import { ApplicationHistoryFilterKeys } from 'automation-ui-management/constants/ApplicationHistoryFilterKeys';
import { GET_ASSOCIATED_ACTION_TYPE_IDS } from 'automation-ui-management/queries/actionQueries';
import { getDefaultedApplicationFilters } from 'automation-ui-management/records/ApplicationHistoryFilters/ApplicationHistoryFilterUtils';
export const useApplicationHistoryFilters = () => {
  const location = useLocation();
  const history = useHistory();
  const filters = new ApplicationHistoryFilters(parseLocation(location));
  const updateFilters = updates => {
    const defaultedFilters = getDefaultedApplicationFilters(updates);
    atomicQueryUpdate(updates, defaultedFilters, history);
  };
  const clearFilters = () => {
    atomicQueryUpdate(undefined, Object.values(ApplicationHistoryFilterKeys), history);
  };
  return {
    filters,
    updateFilters,
    clearFilters
  };
};
export const useGetAssociatedActionTypeIds = (actionTypeId, flowObjectTypeId) => {
  const isBuiltInAction = actionTypeId && actionTypeId.includes('-');
  const {
    data,
    loading,
    error
  } = useQuery(GET_ASSOCIATED_ACTION_TYPE_IDS, {
    variables: {
      actionTypeId
    },
    skip: !actionTypeId || !isBuiltInAction
  });
  const actionTypeIds = data ? getIn(['actionTypeIds', 'results'], data) : [];

  /**
   * Contact flows are being migrated from CLASSIC_ENROLL_IN_WORKFLOW to
   * ENROLL_IN_FLOW. Since both are built-in actions rather than custom
   * actions, we need to add in the 'associated' actionTypeIds separately
   * from the associatedActionTypeIds query above.
   */
  if (flowObjectTypeId === CONTACT_ID && actionTypeId === ENROLL_IN_FLOW) {
    actionTypeIds.push(ENROLL_IN_FLOW, CLASSIC_ENROLL_IN_WORKFLOW);
  }
  return {
    actionTypeIds,
    loading,
    error
  };
};